import { render, staticRenderFns } from "./DashBoardPerformanceFaculty.vue?vue&type=template&id=f3ca2826&scoped=true"
import script from "./DashBoardPerformanceFaculty.vue?vue&type=script&lang=js"
export * from "./DashBoardPerformanceFaculty.vue?vue&type=script&lang=js"
import style0 from "./DashBoardPerformanceFaculty.vue?vue&type=style&index=0&id=f3ca2826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca2826",
  null
  
)

export default component.exports